import { render, staticRenderFns } from "./MortgageGuidanceSelectionPage.vue?vue&type=template&id=cfa74248&scoped=true"
import script from "./MortgageGuidanceSelectionPage.vue?vue&type=script&lang=js"
export * from "./MortgageGuidanceSelectionPage.vue?vue&type=script&lang=js"
import style0 from "./MortgageGuidanceSelectionPage.vue?vue&type=style&index=0&id=cfa74248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa74248",
  null
  
)

export default component.exports